var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SAVE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #SAVE .cls-1 {\n        fill: #f5f5f5;\n      }\n\n      #SAVE .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_352",
    "data-name": "Pfad 352",
    className: "cls-1",
    d: "M29.9,15.9V16A13.95,13.95,0,1,1,2,16,14.041,14.041,0,0,1,16,2h.1V0H16A16,16,0,1,0,32,16v-.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_353",
    "data-name": "Pfad 353",
    className: "cls-2",
    d: "M16.4,22.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_354",
    "data-name": "Pfad 354",
    className: "cls-1",
    d: "M15.4,23.4,8.5,13.2,11,11.5l5,7.3,8.2-16,2.7,1.4-9.7,19A1.087,1.087,0,0,1,15.4,23.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.f67ca77c4a81d302a9e753417554a59f.svg";
export { ForwardRef as ReactComponent };